import { EqlFieldByID } from '@modules/queryBuilder/hooks/useFetchEQLReferences';
import {
  OperationType,
  WhereClause,
} from 'v2/core/services/queryBuilder/whereClause';
import {
  QueryStringMetadataOptionFromFilter,
  QueryStringNonMetadataOptionFromFilter,
  QueryStringOptionFromFilter,
} from '../types';
import { getQueryStringOptionFromFilter } from './getQueryStringOptionFromFilter';

export interface NestedQueryStringOptions {
  fieldName: undefined;
  conjunction: OperationType | undefined;
  params:
    | (QueryStringOptionFromFilter | NestedQueryStringOptions)[]
    | undefined;
}

type FormattedQueryStringOptionsFromWhereClause =
  | QueryStringNonMetadataOptionFromFilter
  | QueryStringMetadataOptionFromFilter
  | NestedQueryStringOptions
  | undefined;

export const transformWhereClauseToFieldNameValues = (
  whereClause: WhereClause,
  eqlFieldByID: EqlFieldByID,
  isUnifiedFieldEnabled: boolean,
  shouldRemoveFileUploadPrefix: boolean,
): FormattedQueryStringOptionsFromWhereClause[] | undefined => {
  if (whereClause.filter) {
    return [
      getQueryStringOptionFromFilter(
        whereClause,
        eqlFieldByID,
        isUnifiedFieldEnabled,
      ),
    ];
  }

  function toQueryStringOption(
    param: WhereClause,
  ): QueryStringOptionFromFilter | NestedQueryStringOptions {
    if (param.filter) {
      return getQueryStringOptionFromFilter(
        param,
        eqlFieldByID,
        isUnifiedFieldEnabled,
        shouldRemoveFileUploadPrefix,
      );
    }

    const params = param.op?.params
      .map((param) => {
        return toQueryStringOption(param);
      })
      .filter(Boolean);

    if (!params || params?.length <= 1) {
      return params?.[0];
    }

    return {
      fieldName: undefined,
      conjunction: param.op?.type,
      params,
    };
  }

  return whereClause.op?.params.map((param) => {
    return toQueryStringOption(param);
  });
};
